module.exports = __webpack_public_path__ + "static/media/LT Grey 1009.afde7f8e.jpg";